import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/@mui+material@7.3.6_@emotion+react@11.14.0_@types+react@19.2.7_react@19.1.0__@emotion+s_c7d185982f0fdc3057d42a25cc5a0961/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/@mui+material@7.3.6_@emotion+react@11.14.0_@types+react@19.2.7_react@19.1.0__@emotion+s_c7d185982f0fdc3057d42a25cc5a0961/node_modules/@mui/material/esm/Typography/Typography.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/about/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["LegalLink"] */ "/app/src/app/components/legal/LegalLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Stripe"] */ "/app/src/app/components/stripe/stripe.tsx");
